<template>
  <span
    v-if="label"
    class="meta"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'Label',
  props: {
    label: {
      type: String,
      default: 'Label'
    }
  }
}
</script>


<docs>
  ```vue
  <Label label="label" />
  ```
</docs>
